export default {
  state: {
    solicitationReport: "",
    excelReportComponent: "Solicitations",
  },

  getters: {
    getSolicitationReport(state) {
      return state.solicitationReport;
    },

    getExcelReportComponent: (state) => state.excelReportComponent,
  },

  mutations: {
    setSolicitationReport(state, data) {
      state.solicitationReport = data;
    },

    setExcelReportComponent(state, component) {
      state.excelReportComponent = component;
    },
  },

  actions: {
    changeSolicitationReport(context, data) {
      context.commit("setSolicitationReport", data);
    },

    changeExcelReportComponent(context, component) {
      context.commit("setExcelReportComponent", component);
    },
  },
};
